<template>
  <thux-table
    :instance="instance"
    :instance-name="instanceName"
    :order-by-dict="orderByDict"
    :goBack="goBack"
    :list="list"
    :fieldName="fieldName"
    :fields="fields"
    :fields-column="fieldsColumn"
    :select-all="selectAll"
    :selected-list="selectedList"
    :get-local-selected-all="getLocalSelectedAll"
    :local-selected-list="localSelectedList"
    @check-all="checkAll('id')"
    @check-none="checkNone('id')"
    @set-selected-row="setSelectedRow($event, 'id')"
    :show-checks="showChecks"
    :showDetailButton="showDetailButton"
    @change-status="changeInstanceStatus"
    @sort-changed="orderTable"
    @remove-order-by="removeOrderFromTable"
    @open-detail-form="$emit('open-detail-form', $event)"
  >
  </thux-table>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { TYPES as DOCUMENT_TYPES } from '../../document/document/store'

import ThuxTableMixin from '@/components/thux-table/ThuxTableMixin'
import ThuxTableChecksMixin from '@/components/thux-table/thux-table-checks/ThuxTableChecksMixin'

export default {
  name: 'TrainingDocumentsTable',
  mixins: [ThuxTableMixin, ThuxTableChecksMixin],
  data () {
    return {
      showAdvancedSearch: true,
      toggleAdvancedSearch: true,
      searchfields: [
        {
          key: 'filter__name__icontains',
          placeholder: this.$t('Name contains'),
          type: 'text',
          col: 6
        },
        {
          key: 'filter__acronym__icontains',
          placeholder: this.$t('Acronym contains'),
          type: 'text',
          col: 6
        }
      ],
      fields: [
        {
          key: 'checks',
          label: this.$t('')
        },
        {
          key: 'name',
          label: this.$t('Name'),
          type: 'text',
          thClass: 'text-nowrap',
          tdClass: 'text-nowrap',
          sortable: false,
          value: 'name'
        },
        {
          key: 'acronym',
          label: this.$t('Acronym'),
          tdClass: 'text-nowrap',
          thClass: 'text-nowrap',
          sortable: false,
          value: 'acronym'
        }
      ],
      fieldsColumn: ['name', 'acronym'],
      instance: undefined
    }
  },
  computed: {
    ...mapGetters({
      selectAll: DOCUMENT_TYPES.GENERIC.document.document.LIST.GETTERS.selectAll,
      selectedList: DOCUMENT_TYPES.GENERIC.document.document.LIST.GETTERS.selectedList
    }),
    showChecks () {
      return true
    },
    showDetailButton () {
      return true
    }
  },
  methods: {
    ...mapMutations({
      setSelectedList:
        DOCUMENT_TYPES.GENERIC.document.document.LIST.MUTATIONS.setSelectedList,
      setSelectAll: DOCUMENT_TYPES.GENERIC.document.document.LIST.MUTATIONS.setSelectAll
    }),
    ...mapActions({
      ...DOCUMENT_TYPES.GENERIC.document.document.LIST.ACTIONS
    })
  }
}
</script>
